import { render, staticRenderFns } from "./TalentApplyAdmin.vue?vue&type=template&id=54da81b2"
import script from "./TalentApplyAdmin.vue?vue&type=script&lang=js"
export * from "./TalentApplyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports